import { css } from '@emotion/react';
import { p2r, PrimaryProps } from '../../styles/fonts';
import { breakpoints } from '../../styles';

const styles = css`
  .layout-header-wrapper {
    position: relative;
    width: 100%;
    max-width: 1440px;
    padding: ${p2r(16)} 32px;
    margin: 0 auto;
  }

  .headEconSec-wrapper {
    & > div > header > div > div {
      border-top: none;
      border-bottom: none;
    }
  }

  .logo {
    max-width: 128px;
    min-height: ${p2r(64)};
  }

  .logo-href {
    width: 100%;
  }

  .layout-HeadAdv-block .HeadAdv-logo {
    position: relative;
    padding-bottom: 0;
  }

  .layout-HeadAdv-block .HeadAdv-logo > div > div > div {
    position: absolute;
    right: 50px;
  }

  .head-adv-wrapper {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .css-w3a1bh-AdvertStyling {
    [data-event-category='Sponsor'] {
      span {
        display: none;
      }

      a {
        margin: 0;
      }
    }

    h3 {
      font-size: ${p2r(14)};
      font-weight: 500;
      line-height: ${p2r(17)};
      text-transform: lowercase;
      letter-spacing: normal;

      @media (max-width: ${breakpoints.tablet}px) {
        max-width: 100%;
      }

      ${PrimaryProps}
    }

    h3::first-letter {
      font-size: 15px;
      text-transform: uppercase;

      @media (max-width: ${breakpoints.tablet}px) {
        font-size: ${p2r(11)};
      }
    }
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .layout-header-wrapper {
      max-width: 100%;
      padding: ${p2r(10)} 16px;
    }

    .logo {
      max-width: 100px;
      min-height: ${p2r(50)};
    }

    .layout-HeadAdv-block .HeadAdv-logo > div > div > div {
      right: 16px;
    }
  }
`;

export default styles;
